/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.09.2016.
 */

import _get from 'lodash/get';

export const GET_METADATA = 'get-metadata-for-vlive';

export function GetMetadata(channelId) {

  return {
    type: GET_METADATA,
    meta: {
      key: channelId
    },
    payload: lh.common.request('v2/virtual-live/v1/playlists/' + channelId + '/metadata')
      .then((res) => {

        return _get(res, 'metadata.overlays', []);
      })
  };
}



// WEBPACK FOOTER //
// ./src/actions/metadata/actions-metadata.js